<template>
  <a-modal v-model="visible" title="New User" :destroyOnClose="true">
    <a-form-model ref="newUserForm" :model="user" :rules="rules" layout="vertical">
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="Email" prop="email">
            <a-input placeholder="Email" v-model="user.email" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="Business" prop="businessId">
            <a-select v-model="user.businessId" style="width: 100%">
              <a-select-option v-for="business in businesses" :key="business.id" :value="business.id">
                {{ business.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="Password" prop="password">
            <a-input placeholder="Password" type="password" v-model="user.password" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="Confirm Password" prop="confirmPassword">
            <a-input placeholder="Confirm Password" type="password" v-model="user.confirmPassword" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="Is Active" prop="isActive">
            <a-switch v-model="user.isActive" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <template #footer>
      <a-button type="primary" @click="save" :loading="isSaving">Save</a-button>
      <a-button @click="cancel">Cancel</a-button>
    </template>
  </a-modal>
</template>
<script>
import { usersMutations } from '../../Store/store';
import { helper } from '../../Utilities/helper';

export default {
  props: {
    value: Boolean,
    user: {
      type: Object,
      defualt: () => ({}),
    },
    businesses: Array,
  },
  data() {
    return {
      rules: {
        username: [{ required: true, message: 'Please input Username', trigger: 'blur' }],
        email: [
          { required: true, message: 'Please input an Email', trigger: 'blur' },
          { validator: helper.userEmailValidator, trigger: 'blur' },
        ],
        password: [{ required: true, message: 'Please input password', trigger: 'blur' }],
        confirmPassword: [
          { required: true, message: 'Please input Confirm Password', trigger: 'blur' },
          { validator: this.confirmPasswordValidator, trigger: 'blur' },
        ],
        businessId: [{ required: true, message: 'Please pick a Business', trigger: 'change' }],
      },
      isSaving: false,
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    confirmPasswordValidator(rule, value, callback) {
      if (value && value !== this.user.password) {
        callback('The two passwords are inconsistent');
      }

      callback();
    },
    cancel() {
      this.visible = false;
    },
    save() {
      this.$refs.newUserForm.validate(async (valid) => {
        if (valid) {
          const tokenKey = this.businesses.find((b) => b.id === this.user.businessId)?.tokenKey;
          this.isSaving = true;

          try {
            await usersMutations.addUser({
              username: this.user.email,
              email: this.user.email,
              password: this.user.password,
              businessId: this.user.businessId,
              isActive: this.user.isActive,
              tokenKey: tokenKey,
            });

            this.visible = false;
          } catch (error) {
            this.$message.error(error.response?.data?.errors[0]?.message ?? error.message);
          } finally {
            this.isSaving = false;
          }
        }
      });
    },
  },
};
</script>

<style></style>